<div class="kodit-card-tab">
  <p-tabView
    [(activeIndex)]="activeIndex"
    (activeIndexChange)="handleIndexChange($event)"
  >
    <p-tabPanel header="Izlazna otpremnica"></p-tabPanel>
    <p-tabPanel header="Ulazna prijemnica"></p-tabPanel>
  </p-tabView>

  <div [ngSwitch]="activeIndex">
    <div *ngSwitchCase="0">
     <kodit-page>
       <kodit-eotpremnica-table
          [vrstaOtpremnice]="VrstaDokumentaOtpremnica.IZLAZNA"
       ></kodit-eotpremnica-table>
     </kodit-page>
    </div>
    <div *ngSwitchCase="1">
      <kodit-page>
        <kodit-eprijemnica-table
          [vrstaOtpremnice]="VrstaDokumentaOtpremnica.ULAZNA"
        ></kodit-eprijemnica-table>
      </kodit-page>
    </div>
  </div>
</div>
